import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../store/loaderSlice";
import axiosInstance from "../../../utils/axiosInstance";

const FullBetListModal = ({ show, onClose }) => {
  const { marketId } = useParams();

  const [matchedBets, setMatchedBets] = useState([]);
  const [settings, setSettings] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
const dispatch = useDispatch();

  const getBetMasterName = (bet) => {
    if (bet?.master) return bet.master;
    const shares = bet?.master_sharing || [];
    if (!shares.length) return "";
    const direct = [...shares].sort(
      (a, b) => (b.user_role || 0) - (a.user_role || 0)
    )[0];
    return direct?.uname || "";
  };
  // Disable body scroll
  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [show]);

  // Reset page on open
  useEffect(() => {
    if (show) {
      setPage(1);
      fetchSettings();
    }
  }, [show]);

  // Fetch settings
  const fetchSettings = async () => {
    try {
      const res = await axiosInstance.get("/markets/settings");
      setSettings(res.data || {});
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch matched bets (with filters)
  useEffect(() => {
    if (!show) return;
    if (!settings) return;

    fetchMatchedBets();
  }, [show, page, limit, settings]);

  const fetchMatchedBets = async () => {
    try {
      setLoading(true);
      await dispatch(setLoader(true));

      const response = await axiosInstance.get(
        `/markets/full-bet-list/${marketId}`,
        {
          params: {
            page,
            limit,
            from_date: settings?.from_date || null,
            to_date: settings?.to_date || null,
            bet_type: settings?.bet_type || null,
            amount_min: settings?.amount_min || null,
            amount_max: settings?.amount_max || null,
            market_type: settings?.market_type || null,
            user_bets: settings?.user_bets || null
          }
        }
      );

      setMatchedBets(response.data.matched || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalCount(response.data.totalCount || 0);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      await dispatch(setLoader(false));
    }
  };

  const getRowColor = (type) => {
    return type && (type.toLowerCase() === "l" || type.toLowerCase() === "n")
      ? "rgb(252, 227, 228)"
      : "rgb(232, 246, 252)";
  };

  if (!show) return null;

  return (
    <>
      <style>{`
        .fullbet-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          z-index: 1050;
        }
        .fullbet-modal-wrapper {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1051;
        }
        .fullbet-modal {
          background: #fff;
          width: 95%;
          max-width: 1100px;
          border-radius: 6px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.25);
          max-height: 90vh;
          display: flex;
          flex-direction: column;
        }
        .fullbet-modal-header {
          padding: 15px 20px;
          border-bottom: 1px solid #ddd;
          font-weight: 600;
        }
        .fullbet-modal-body {
          padding: 20px;
          overflow-y: auto;
        }
        .fullbet-modal-footer {
          padding: 15px 20px;
          border-top: 1px solid #ddd;
        }
      `}</style>

      <div className="fullbet-modal-overlay" onClick={onClose} />

      <div className="fullbet-modal-wrapper">
        <div className="fullbet-modal">
          <div className="fullbet-modal-header d-flex justify-content-between align-items-center">
            <span>Matched Bets ({totalCount})</span>
            <button className="btn btn-sm btn-danger" onClick={onClose}>
              ×
            </button>
          </div>

          <div className="fullbet-modal-body">
            {/*
            <h5 className="mb-3">UnMatched (0)</h5>
        
            <div className="table-responsive mb-4">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Runner</th>
                    <th>Price</th>
                    <th>Size</th>
                    <th>Customer</th>
                    <th>Dealer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Unmatched Bets
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
      */}

            {loading && (
              <div
                style={{ width: "100%", textAlign: "center", display: "block" }}
              >
                <img src="../../assets/images/loadinggif.gif" alt="Loader" />
              </div>
            )}

            <div className="table-responsive">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Runner</th>
                    <th>Price</th>
                    <th>Size</th>
                    <th>Customer</th>
                    <th>Dealer</th>
                  </tr>
                </thead>
                <tbody>
                  {matchedBets.length > 0
                    ? matchedBets.map((bet, index) => (
                        <tr
                          key={index}
                          style={{ backgroundColor: getRowColor(bet.type) }}
                        >
                          <td>{bet.section}</td>
                          <td>{bet.rate}</td>
                          <td>{bet.amnt}</td>
                          <td>{bet.uname}</td>
                          <td>{getBetMasterName(bet)}</td>
                        </tr>
                      ))
                    : !loading && (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="fullbet-modal-footer d-flex justify-content-between align-items-center">
            <select
              className="form-control form-control-sm"
              style={{ width: "100px" }}
              value={limit}
              onChange={(e) => {
                setPage(1);
                setLimit(Number(e.target.value));
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>

            <div>
              <button
                className="btn btn-sm btn-secondary mr-2"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Prev
              </button>

              <span>
                Page {page} of {totalPages}
              </span>

              <button
                className="btn btn-sm btn-secondary ml-2"
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>
            </div>

            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FullBetListModal;